import { Stack } from "@assetwatch/ui";
import type { EnterpriseAssetsV2SummaryResponse } from "../api/enterpriseClient";
import { AssetsV2HighRiskAssetsTable } from "./AssetsV2HighRiskAssetsTable";
import { AssetsV2MetricsGrid } from "./AssetsV2MetricsGrid";
import { AssetsV2RiskDistribution } from "./AssetsV2RiskDistribution";

export function AssetsV2Dashboard({
  customerId,
  response,
}: {
  customerId: number;
  response: EnterpriseAssetsV2SummaryResponse;
}) {
  return (
    <Stack gap={24}>
      <AssetsV2RiskDistribution summary={response.summary} />
      <AssetsV2MetricsGrid summary={response.summary} />
      <AssetsV2HighRiskAssetsTable
        customerId={customerId}
        summary={response.summary}
        hasFacilityGroups={response.facilityGroups.length > 0}
        facilities={response.facilities}
      />
    </Stack>
  );
}
